import React from 'react'

function ArrowRight(props: any) {

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="none" d="M4.16699 10H15.8337" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path fill="none" d="M10 4.16675L15.8333 10.0001L10 15.8334" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ArrowRight
